module.exports = __webpack_public_path__ + "static-portal/img/xzz-czyh.e783ce1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-czyh.jpg
// module id = EaHg
// module chunks = 4